var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ExNvrDiagnosticsPanelSectionHeader',{attrs:{"title":_vm.title,"tasks":_vm.relatedTasks}}),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.configLists),function(list,index){return _c('div',{key:index,staticClass:"ex-nvr-diagnostics__result",class:{
        'pl-2': index !== 0,
        'ex-nvr-diagnostics__result--disabled': list.isDisabled,
      }},[_c('ExNvrDiagnosticsPanelSectionConfigsList',{attrs:{"items":list.items,"grid-layout":list.gridLayout}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }